const initialState = {
  showUploadDialog: false,
  errorMessage: '',
  listLoading: false,
  data: [],
  uploadMessage: '',
  uploadError: {},
  fileLoading: false,
};

const payRateUploads = (state = initialState, { type, payload }) => {
  switch (type) {
    case 'PAY_RATE_UPLOADS_LIST_REQUEST':
      return {
        ...state,
        listLoading: true,
      };
    case 'PAY_RATE_UPLOADS_LIST_REQUEST_SUCCESS':
      return {
        ...state,
        listLoading: false,
        data: payload,
      };
    case 'PAY_RATE_UPLOADS_LIST_REQUEST_FAILURE':
      return {
        ...state,
        listLoading: false,
        errors: payload.errors,
      };
    case 'PAY_RATE_UPLOADS_FILE_UPLOAD':
      return {
        ...state,
        fileLoading: true,
        uploadMessage: '',
        uploadError: {},
      };
    case 'PAY_RATE_UPLOADS_FILE_UPLOAD_SUCCESS':
      state.data.unshift(payload);
      return {
        ...state,
        data: state.data,
        fileLoading: false,
        showUploadDialog: false,
        uploadMessage: 'Success',
      };
    case 'PAY_RATE_UPLOADS_FILE_UPLOAD_FAILURE':
      return {
        ...state,
        fileLoading: false,
        uploadError: payload.errors,
      };
    case 'PAY_RATE_UPLOADS_TOGGLE_DIALOG':
      return {
        ...state,
        showUploadDialog: !state.showUploadDialog,
        uploadError: {},
      };
    default:
      return state;
  }
};

const getLoadingStatus = state => state.listLoading;
const getListData = state => state.data;
const getErrorMessage = state => state.errorMessage;
const getUploadError = state => state.uploadError;
const getUploadMesage = state => state.uploadMessage;
const getFileLoading = state => state.fileLoading;
const getShowDialog = state => state.showUploadDialog;

export default payRateUploads;

export {
  getListData,
  getLoadingStatus,
  getErrorMessage,
  getUploadError,
  getUploadMesage,
  getFileLoading,
  getShowDialog,
};



// WEBPACK FOOTER //
// ./client/app/reducers/pay_rate_uploads.js